import { apiCall } from './gqlClient';

const GETUSERWORKOUTPROGRESSDETAILS_QUERY = `
  query getUserWorkoutProgressDetails($id: String!) {
    getUserWorkoutProgressDetails(id: $id)
    {
      id
			userId
			workoutId
			userPlanId
			duration
			dateCreated
			totalPercentage
			providerId
			note
			rating
			workoutTitle
			planTitle
			groupId
      ...fragments
    }
  }`;

export const getUserWorkoutProgressDetailsApiCall = async ({id}, fragments = null) => apiCall({ query: GETUSERWORKOUTPROGRESSDETAILS_QUERY, variables: {id}, fragments });

const GETUSERWORKOUTPROGRESSDETAILSBYOWNER_QUERY = `
  query getUserWorkoutProgressDetailsByOwner($userId: Int!, $userPlanId: String!) {
    getUserWorkoutProgressDetailsByOwner(userId: $userId, userPlanId: $userPlanId)
    {
      planTitle
			workoutTitle
			userId
      ...fragments
    }
  }`;

export const getUserWorkoutProgressDetailsByOwnerApiCall = async ({userId, userPlanId}, fragments = null) => apiCall({ query: GETUSERWORKOUTPROGRESSDETAILSBYOWNER_QUERY, variables: {userId, userPlanId}, fragments });

const GETUSERWORKOUTPROGRESSDETAILSBYGROUP_QUERY = `
  query getUserWorkoutProgressDetailsByGroup($groupId: Int!, $groupPlanId: String!) {
    getUserWorkoutProgressDetailsByGroup(groupId: $groupId, groupPlanId: $groupPlanId)
    {
      groupName
			planTitle
			groupId
      ...fragments
    }
  }`;

export const getUserWorkoutProgressDetailsByGroupApiCall = async ({groupId, groupPlanId}, fragments = null) => apiCall({ query: GETUSERWORKOUTPROGRESSDETAILSBYGROUP_QUERY, variables: {groupId, groupPlanId}, fragments });

const GETALLUSERWORKOUTACTIVITIES_QUERY = `
  query getAllUserWorkoutActivities($userId: Int!) {
    getAllUserWorkoutActivities(userId: $userId)
    {
      id
			userId
			workoutId
			userPlanId
			duration
			dateCreated
			totalPercentage
			providerId
			note
			rating
			workoutTitle
			planTitle
			groupId
      ...fragments
    }
  }`;

export const getAllUserWorkoutActivitiesApiCall = async ({userId}, fragments = null) => apiCall({ query: GETALLUSERWORKOUTACTIVITIES_QUERY, variables: {userId}, fragments });

const GETUSERWORKOUTPROGRESSMONTHS_QUERY = `
  query getUserWorkoutProgressMonths {
    getUserWorkoutProgressMonths
  }`;

export const getUserWorkoutProgressMonthsApiCall = async () => apiCall({ query: GETUSERWORKOUTPROGRESSMONTHS_QUERY, variables: {}});

const GETUSERWORKOUTPROGRESSPERIOD_QUERY = `
  query getUserWorkoutProgressPeriod($periodDays: Int!) {
    getUserWorkoutProgressPeriod(periodDays: $periodDays)
    {
      workoutsFinished
			totalProgress
      ...fragments
    }
  }`;

export const getUserWorkoutProgressPeriodApiCall = async ({periodDays}, fragments = null) => apiCall({ query: GETUSERWORKOUTPROGRESSPERIOD_QUERY, variables: {periodDays}, fragments });

const GETUSERWORKOUTPROGRESSFORMONTH_QUERY = `
  query getUserWorkoutProgressForMonth($date: DateTime!) {
    getUserWorkoutProgressForMonth(date: $date)
    {
      totalPercentage
			dateCreated
			duration
			totalExercises
			maxWeight
			exercises
      ...fragments
    }
  }`;

export const getUserWorkoutProgressForMonthApiCall = async ({date}, fragments = null) => apiCall({ query: GETUSERWORKOUTPROGRESSFORMONTH_QUERY, variables: {date}, fragments });

const CREATEUSERWORKOUTPROGRESS_QUERY = `
  mutation createUserWorkoutProgress($request: UserWorkoutProgressInput!) {
    createUserWorkoutProgress(request: $request)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const createUserWorkoutProgressApiCall = async ({request}, fragments = null) => apiCall({ query: CREATEUSERWORKOUTPROGRESS_QUERY, variables: {request}, fragments });
